import React  from 'react'

import {FieldViewProps} from "../../../render/view"

const debug = false
// const debug = "FieldColor_View"

export default function FieldColor_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const option = props.field._getOption(value)

    debug && console.log(debug, 'render', value, option, props.field.fieldId, props.model)

    const classes = Classes("ui5-color-picker", "gd-c-{0}".f(option.value || value), props.className)

    return <div className={classes}/>

}
